import React from 'react';
import { __RouterContext as RouterContext, RouteComponentProps } from 'react-router';

function useRouter<
  Params extends { [K in keyof Params]?: string } = Record<string, string>,
  StateShape = Record<string, unknown>,
>() {
  return React.useContext(RouterContext) as RouteComponentProps<Params, undefined, StateShape>;
}

export default useRouter;
